import { useCallback } from "react";
import {
  CREATE_MERCHANT_VIEW_PATH,
  EDIT_MERCHANT_VIEW_PATH,
  MERCHANTS_VIEW_PATH,
  MERCHANT_DETAIL_VIEW_PATH,
} from "src/merchants/views/MerchantPaths";
import {
  type ParamsOverride,
  usePathHandler,
} from "src/shared/hooks/usePathHandler";

export const useMerchantsViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (params?: ParamsOverride) => pathHandler(MERCHANTS_VIEW_PATH, params),
    [pathHandler],
  );
};

export const useMerchantCreateViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    () => pathHandler(CREATE_MERCHANT_VIEW_PATH),
    [pathHandler],
  );
};

export const useMerchantDetailViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (merchantUuid: string) =>
      pathHandler(
        MERCHANT_DETAIL_VIEW_PATH.replace(":merchantUUID", merchantUuid),
      ),
    [pathHandler],
  );
};

export const useMerchantEditViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (merchantUuid: string) =>
      pathHandler(
        EDIT_MERCHANT_VIEW_PATH.replace(":merchantUUID", merchantUuid),
      ),
    [pathHandler],
  );
};
